export enum LineSummaryFileType {
  FILE_TYPE_UNSET = 'FILE_TYPE_UNSET', // Do not use, needed because of proto3 limitations
  FILE_TYPE_LINE_IDS = 'FILE_TYPE_LINE_IDS',
  FILE_TYPE_ICCIDS = 'FILE_TYPE_ICCIDS',
  FILE_TYPE_ENDUSER_IDS = 'FILE_TYPE_ENDUSER_IDS',
  FILE_TYPE_PHONENUMBERS = 'FILE_TYPE_PHONENUMBERS',
}
